var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from "styled-components";
export var Verify = function (_a) {
    var title = _a.title, isVerified = _a.isVerified, message = _a.message;
    var renderTitle = function () {
        if (title.length) {
            return _jsx("h5", __assign({ className: "card-title text-success" }, { children: title }));
        }
        else if (isVerified) {
            return _jsx("h5", __assign({ className: "card-title text-success" }, { children: "Success!" }));
        }
        else {
            return _jsx("h5", __assign({ className: "card-title text-danger" }, { children: "Error!" }));
        }
    };
    var renderLoginButton = function () {
        return (_jsx("a", __assign({ href: "/login", className: "btn btn-sm btn-primary" }, { children: "To login" })));
    };
    return (_jsx(CardInfo, __assign({ className: "card mx-auto my-0 dc-card-info" }, { children: _jsxs("div", __assign({ className: "card-body" }, { children: [renderTitle(), _jsx("p", __assign({ className: "card-text" }, { children: message })), !title && renderLoginButton()] })) })));
};
var CardInfo = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  min-width: 20rem;\n  max-width: 40rem;\n"], ["\n  min-width: 20rem;\n  max-width: 40rem;\n"])));
var templateObject_1;
